import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const legalDocuments = [
  {
    id: 'mesafeli-satis',
    title: 'Mesafeli Satış Sözleşmesi',
    content: (
      <div className="space-y-6">
        <p><strong>MADDE 1 - TARAFLAR</strong></p>
        <p>
          İşbu sözleşme, bir tarafta ürün satışı yapan ve ödeme altyapısını sağlayan May Plastik yetkili satış kanalı Ayz Plastik (bundan sonra SATICI olarak anılacaktır) ile diğer tarafta ürünü satın alan tüketici (bundan sonra ALICI olarak anılacaktır) arasında elektronik ortamda akdedilmiştir.
        </p>
        
        <p><strong>MADDE 2 - SÖZLEŞMENİN KONUSU</strong></p>
        <p>
          İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait www.ayzplastik.com internet sitesinden elektronik ortamda siparişini yaptığı ürünün satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.
        </p>

        <p><strong>MADDE 3 - ÖDEME VE GÜVENLİK</strong></p>
        <p>
          Sitemiz üzerinden yapılan tüm kredi kartı ve banka kartı ödemeleri, BDDK lisanslı <strong>İyzico (May Plastik POS)</strong> altyapısı kullanılarak 256-bit SSL şifreleme yöntemiyle gerçekleştirilmektedir. SATICI, ALICI'nın kredi kartı bilgilerini hiçbir şekilde kendi sunucularında saklamaz.
        </p>
      </div>
    )
  },
  {
    id: 'iade-kosullari',
    title: 'İptal ve İade Koşulları',
    content: (
      <div className="space-y-6">
        <p><strong>CAYMA HAKKI</strong></p>
        <p>
          ALICI, satın aldığı ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa teslim tarihinden itibaren 14 (on dört) gün içerisinde hiçbir hukuki ve cezai sorumluluk üstlenmeksizin ve hiçbir gerekçe göstermeksizin malı reddederek sözleşmeden cayma hakkına sahiptir.
        </p>
        
        <p><strong>İADE EDİLEMEYECEK ÜRÜNLER</strong></p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Ambalajı açılmış, kullanılmış veya hasar görmüş plastik/polimer ürünler.</li>
          <li>ALICI'nın isteği veya açıkça kişisel ihtiyaçları doğrultusunda özel olarak üretilen ürünler.</li>
          <li>Tek kullanımlık ürünler ve hızlı bozulan veya son kullanma tarihi geçme ihtimali olan mallar.</li>
        </ul>

        <p><strong>İADE SÜRECİ VE ÜCRETLERİ</strong></p>
        <p>
          İade edilecek ürünlerin kutusu, ambalajı ve varsa standart aksesuarları ile birlikte eksiksiz ve hasarsız olarak SATICI'ya teslim edilmesi gerekmektedir. İade işlemlerinde kargo bedeli, aksi belirtilmedikçe SATICI tarafından karşılanır. İade onaylandığında, ürün bedeli 3-5 iş günü içerisinde İyzico üzerinden ALICI'nın ödeme yaptığı hesaba iade edilir.
        </p>
      </div>
    )
  },
  {
    id: 'gizlilik-politikasi',
    title: 'Gizlilik ve Güvenlik Politikası',
    content: (
      <div className="space-y-6">
        <p><strong>KİŞİSEL VERİLERİN KORUNMASI (KVKK)</strong></p>
        <p>
          Ayz Plastik, müşterilerine daha iyi hizmet verebilmek amacıyla bazı kişisel bilgilerinizi (isim, e-posta, telefon vb.) sizlerden talep etmektedir. Sunucularımızda toplanan bu bilgiler, dönemsel kampanya çalışmaları, müşteri profillerine yönelik özel promosyon faaliyetlerinin kurgulanması ve istenmeyen e-postaların iletilmemesine yönelik müşteri "sınıflandırma" çalışmalarında sadece Ayz Plastik bünyesinde kullanılmaktadır.
        </p>

        <p><strong>ÖDEME GÜVENLİĞİ</strong></p>
        <p>
          Ödeme sayfasında istenen kredi kartı bilgileriniz, siteden alışveriş yapan siz değerli müşterilerimizin güvenliğini en üst seviyede tutmak amacıyla hiçbir şekilde Ayz Plastik sunucularında tutulmamaktadır. Tüm ödeme işlemleri, İyzico arayüzü üzerinden banka ve bilgisayarınız/telefonunuz arasında gerçekleşmektedir.
        </p>
      </div>
    )
  },
  {
    id: 'teslimat-kosullari',
    title: 'Teslimat Koşulları',
    content: (
      <div className="space-y-6">
        <p><strong>KARGO VE TESLİMAT SÜRECİ</strong></p>
        <p>
          Siparişleriniz, banka onayı alındıktan sonra en geç 3 (üç) iş günü içerisinde anlaşmalı kargo şirketine teslim edilir. Teslimat adresinin Ayz Plastik (Konya) merkezine uzaklığına göre kargo şirketi 1-3 iş günü içerisinde siparişinizi size ulaştıracaktır.
        </p>
        
        <p><strong>ALICININ YÜKÜMLÜLÜKLERİ</strong></p>
        <p>
          ALICI, sözleşme konusu mal/hizmeti teslim almadan önce muayene edecek; ezik, kırık, ambalajı yırtılmış vb. hasarlı ve ayıplı mal/hizmeti kargo şirketinden teslim almayacaktır. Teslim alınan mal/hizmetin hasarsız ve sağlam olduğu kabul edilecektir. Teslimden sonra mal/hizmetin özenle korunması borcu, ALICI'ya aittir.
        </p>
      </div>
    )
  }
];

export default function Legal() {
  const [activeDoc, setActiveDoc] = useState(legalDocuments[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-brand-cream pt-32 pb-24 px-4 md:px-8">
      <div className="container mx-auto max-w-6xl">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mb-16 md:mb-24"
        >
          <span className="text-sm font-bold tracking-[0.2em] uppercase text-brand-dark/40 mb-4 block">
            Ayz Plastik
          </span>
          <h1 className="text-4xl md:text-6xl font-black text-brand-dark tracking-tighter">
            Yasal Metinler
          </h1>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-12 md:gap-24">
          
          <motion.aside 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="w-full md:w-1/3 lg:w-1/4 shrink-0"
          >
            <nav className="sticky top-32 flex flex-col gap-2">
              {legalDocuments.map((doc) => (
                <button
                  key={doc.id}
                  onClick={() => setActiveDoc(doc)}
                  className={`text-left px-5 py-4 rounded-xl transition-all duration-300 text-sm md:text-base font-medium ${
                    activeDoc.id === doc.id
                      ? 'bg-brand-dark text-white shadow-lg scale-[1.02]'
                      : 'text-brand-dark/60 hover:bg-brand-dark/5 hover:text-brand-dark'
                  }`}
                >
                  {doc.title}
                </button>
              ))}
            </nav>
          </motion.aside>

          <div className="w-full md:w-2/3 lg:w-3/4 min-h-[60vh]">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeDoc.id}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-brand-dark/5"
              >
                <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-8 tracking-tight border-b border-brand-dark/10 pb-6">
                  {activeDoc.title}
                </h2>
                
                <div className="prose prose-lg max-w-none text-brand-dark/70 leading-relaxed text-[15px] md:text-[16px]">
                  {activeDoc.content}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

        </div>
      </div>
    </main>
  );
}